const { windowLoaded } = await import(`./modules/general.js?ver=${paths.cachebuster}`);
const { initMenu } = await import(`./modules/menu.js?ver=${paths.cachebuster}`);
const { initSalesforceW2LForm } = await import(`./modules/sfdc_form.js?ver=${paths.cachebuster}`);

async function main() {
  await windowLoaded();

  try {
    initMenu();
    initSalesforceW2LForm({
      sfdcFormId: 'formContact',
      sfdcLeadSourceDetail: 'Contact Us',
      sfdcThankYouPageUrl: document.location.origin + '/contact-us-thank-you/',
    });
  } catch (err) {
    console.error(err);
  }
}

main();
